import { createAction, props } from '@ngrx/store';
import { EntityRoleEntity } from '../../entities/entity-role.entity';

export const EntityRoleActionTypes = {
    LoadAll: createAction('data/EntityRoles/loadAll'),
    UpdateAll: createAction('data/EntityRoles/updateAll', props<{ Payload: Array<EntityRoleEntity> }>()),
};
